/* Glyfa · Produkt-Mockups (SVG). Erzeugt aus src/js/art.js; klassisches Skript, Zugriff über window.GlyfaArt. */
(function () {
'use strict';
// Glyfa · Produkt-Mockups als SVG (Silhouetten mit Schattierung, Druckfläche, Logo-Platzierung).
// Reiner ES-Modul-Code, läuft im Build (Node) und im Browser (Konfigurator). Keine Abhängigkeiten.
// Eigene Zeichnungen, keine Fremdbilder. Alle Maße in einem Koordinatensystem 600 × 640.

const W = 600;
const H = 640;

const COLORS = {
  tinte: '#131A2B',
  papier: '#F4EFE6',
  ton: '#D2623F',
  moos: '#3C5A4E',
  sand: '#E4D9C6',
  stein: '#5C626D',
};

// Textilfarben (CD: nur 4 Basisfarben) mit Namen und Bühnenhintergrund (Kontrast zur Ware)
const GARMENT = {
  tinte: { hex: '#141B2E', de: 'Tinte', en: 'Ink', stage: '#E7DFD0', light: false },
  papier: { hex: '#EFE8DA', de: 'Natur', en: 'Natural', stage: '#CFC3AE', light: true },
  sand: { hex: '#D9CAAE', de: 'Sand', en: 'Sand', stage: '#EFE9DD', light: true },
  moos: { hex: '#40604F', de: 'Moos', en: 'Moss', stage: '#E7DFD0', light: false },
};

const hexRgb = (h) => {
  if (h.length === 4) h = "#" + h[1] + h[1] + h[2] + h[2] + h[3] + h[3];
  return [1, 3, 5].map((i) => parseInt(h.slice(i, i + 2), 16));
};
const rgbHex = (r) => '#' + r.map((v) => Math.max(0, Math.min(255, Math.round(v))).toString(16).padStart(2, '0')).join('');
const mix = (a, b, t) => {
  const A = hexRgb(a), B = hexRgb(b);
  return rgbHex(A.map((v, i) => v + (B[i] - v) * t));
};
const lum = (h) => {
  const [r, g, b] = hexRgb(h).map((v) => v / 255);
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};
const darker = (h, t) => mix(h, '#000000', t);
const lighter = (h, t) => mix(h, '#ffffff', t);

// Druckflächen (Koordinaten im 600×640-Raster; cmW/cmH = reale Zielgröße für die Auflösungsprüfung)
const AREAS = {
  tshirt: { front: { x: 214, y: 196, w: 172, h: 124, cmW: 28, cmH: 20 } },
  hoodie: { front: { x: 226, y: 290, w: 148, h: 104, cmW: 28, cmH: 20 } },
  polo: { front: { x: 346, y: 198, w: 62, h: 52, cmW: 8, cmH: 6.5 } },
  beanie: { front: { x: 232, y: 394, w: 136, h: 90, cmW: 7, cmH: 4.5 } },
  socken: { front: { x: 320, y: 196, w: 108, h: 100, cmW: 6.5, cmH: 6.5, extra: [{ x: 172, y: 196, w: 108, h: 100 }] } },
  slides: { front: { x: 124, y: 124, w: 92, h: 60, cmW: 6, cmH: 4 } },
  flasche: { front: { x: 244, y: 268, w: 112, h: 150, cmW: 5, cmH: 7 } },
  tasche: { front: { x: 172, y: 262, w: 256, h: 262, cmW: 27, cmH: 27 } },
  notizbuch: { front: { x: 224, y: 176, w: 130, h: 130, cmW: 6, cmH: 6 } },
};
// Weitere Druckpositionen (Brust links = links vom Träger = im Bild rechts). „center“ ist immer AREAS[kind].front.
const PLACEMENTS = {
  tshirt: { left: { x: 330, y: 200, w: 70, h: 58, cmW: 10, cmH: 8 }, right: { x: 200, y: 200, w: 70, h: 58, cmW: 10, cmH: 8 } },
  hoodie: { left: { x: 340, y: 228, w: 58, h: 48, cmW: 10, cmH: 8 }, right: { x: 202, y: 228, w: 58, h: 48, cmW: 10, cmH: 8 } },
};
function placeArea(kind, place) {
  const pl = PLACEMENTS[kind];
  return place && place !== 'center' && pl && pl[place] ? pl[place] : (AREAS[kind] || {}).front;
}
// Lage des Logos in einer Druckfläche: skaliert, dx/dy von −1 (links/oben) bis 1 (rechts/unten) innerhalb der Fläche
function logoRect(area, logo, o = {}, pad = 0.9) {
  const scale = Math.max(0.3, Math.min(1, o.scale ?? 1));
  const r = Math.min((area.w * pad * scale) / logo.w, (area.h * pad * scale) / logo.h);
  const w = logo.w * r, h = logo.h * r;
  const k = (v) => Math.max(-1, Math.min(1, Number(v) || 0));
  return { w, h, x: area.x + ((area.w - w) / 2) * (1 + k(o.dx)), y: area.y + ((area.h - h) / 2) * (1 + k(o.dy)) };
}
// Rückseite (nur Name/Nummer)
const BACK = {
  tshirt: { name: { x: 190, y: 150, w: 220, h: 46 }, num: { x: 200, y: 210, w: 200, h: 220 } },
  hoodie: { name: { x: 190, y: 252, w: 220, h: 46 }, num: { x: 200, y: 310, w: 200, h: 220 } },
};

let uidCounter = 0;
const nextUid = () => 'g' + (++uidCounter).toString(36);

// ---------- Beispiel-Logos (frei erfundene Marken, ausdrücklich Beispiele) ----------
const SAMPLE_LOGOS = {
  mrc: {
    de: 'Run Club (Beispiel)', en: 'Run club (example)', w: 100, h: 112,
    markup: (c) => `
      <path d="M50 4 L92 16 V58 C92 82 72 100 50 108 C28 100 8 82 8 58 V16 Z" fill="${c.main}"/>
      <path d="M50 12 L84 22 V58 C84 77 68 92 50 100 C32 92 16 77 16 58 V22 Z" fill="none" stroke="${c.alt}" stroke-width="2.4"/>
      <path d="M22 76 L78 40" stroke="${c.accent}" stroke-width="7" stroke-linecap="butt"/>
      <text x="50" y="62" text-anchor="middle" font-family="Fraunces, Georgia, serif" font-weight="700" font-size="25" letter-spacing="1" fill="${c.alt}">MRC</text>`,
  },
  atelier: {
    de: 'Studio-Wortmarke (Beispiel)', en: 'Studio wordmark (example)', w: 300, h: 64,
    markup: (c) => `
      <g stroke="${c.accent}" stroke-width="5" stroke-linecap="round"><path d="M26 10 V46 M10 19 L42 37 M42 19 L10 37"/></g>
      <text x="62" y="34" font-family="Fraunces, Georgia, serif" font-weight="600" font-size="32" fill="${c.main}">Atelier</text>
      <text x="62" y="58" font-family="Inter, Arial, sans-serif" font-weight="600" font-size="15" letter-spacing="5.2" fill="${c.main}">BEISPIEL</text>`,
  },
  hc07: {
    de: 'Hybrid-Club (Beispiel)', en: 'Hybrid club (example)', w: 220, h: 110,
    markup: (c) => `
      <text x="2" y="76" font-family="Inter, Arial, sans-serif" font-weight="800" font-size="86" letter-spacing="-3" fill="${c.main}">07</text>
      <path d="M118 90 L150 14" stroke="${c.accent}" stroke-width="8"/>
      <text x="2" y="104" font-family="Inter, Arial, sans-serif" font-weight="700" font-size="16" letter-spacing="6" fill="${c.main}">HYBRID CLUB</text>`,
  },
};

// Logo-Farben je Untergrund: ink = null → Originalfarben der Beispiele passend zum Untergrund
function sampleColors(garmentLight, ink) {
  if (ink && ink !== 'original') return { main: ink, alt: ink, accent: ink };
  return garmentLight
    ? { main: COLORS.tinte, alt: COLORS.papier, accent: COLORS.ton }
    : { main: COLORS.papier, alt: COLORS.tinte, accent: COLORS.ton };
}

// ---------- Helfer ----------
const esc = (s) => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

// Spiegelt eine linke Hälfte (absolute M/L/Q/C/Z-Pfade, Mitte bei x=300) zu einem geschlossenen Gesamtpfad
function fullPath(d) {
  const segs = [];
  let p0 = null, cur = null;
  const re = /([MLQCZ])([^MLQCZ]*)/g;
  let m;
  while ((m = re.exec(d))) {
    const c = m[1];
    const n = m[2].trim().split(/[ ,]+/).filter(Boolean).map(Number);
    if (c === "M") { p0 = [n[0], n[1]]; cur = p0; continue; }
    if (c === "Z") continue;
    const pts = [];
    for (let i = 0; i < n.length; i += 2) pts.push([n[i], n[i + 1]]);
    segs.push({ c, from: cur, pts });
    cur = pts[pts.length - 1];
  }
  const mx = (p) => [600 - p[0], p[1]];
  const f = (p) => p[0].toFixed(1) + "," + p[1].toFixed(1);
  let out = "M" + f(p0);
  for (const sg of segs) out += sg.c + sg.pts.map(f).join(" ");
  for (let i = segs.length - 1; i >= 0; i--) {
    const sg = segs[i];
    if (sg.c === "L") out += "L" + f(mx(sg.from));
    else if (sg.c === "Q") out += "Q" + f(mx(sg.pts[0])) + " " + f(mx(sg.from));
    else if (sg.c === "C") out += "C" + f(mx(sg.pts[1])) + " " + f(mx(sg.pts[0])) + " " + f(mx(sg.from));
  }
  return out + "Z";
}

// Mittensymmetrische Form: linke Hälfte angeben, Ergebnis ist EIN geschlossener Pfad (keine Naht in der Mitte)
function halves(uid, id, d) {
  const full = fullPath(d);
  return {
    def: `<path id="${uid}-${id}" d="${full}"/>`,
    use: (attrs = "") => `<use href="#${uid}-${id}" ${attrs}/>`,
    clip: (cid) => `<clipPath id="${uid}-${cid}"><use href="#${uid}-${id}"/></clipPath>`,
  };
}

// Seitenform (links angeben, rechts gespiegelt kopiert, ohne Verbindung in der Mitte)
function sides(uid, id, d) {
  return {
    def: `<path id="${uid}-${id}" d="${d}"/>`,
    use: (attrs = "") =>
      `<use href="#${uid}-${id}" ${attrs}/><use href="#${uid}-${id}" transform="translate(600 0) scale(-1 1)" ${attrs}/>`,
    clip: (cid) =>
      `<clipPath id="${uid}-${cid}"><use href="#${uid}-${id}"/><use href="#${uid}-${id}" transform="translate(600 0) scale(-1 1)"/></clipPath>`,
  };
}

function baseDefs(uid, hex, o) {
  const L = lum(hex);
  const shadeA = L > 0.5 ? 0.2 : 0.42;
  const hiA = L > 0.5 ? 0.38 : 0.1;
  return `
    <linearGradient id="${uid}-gx" gradientUnits="userSpaceOnUse" x1="0" x2="600" y1="0" y2="0">
      <stop offset="0" stop-color="#000" stop-opacity="${shadeA}"/>
      <stop offset=".14" stop-color="#000" stop-opacity="${shadeA * 0.12}"/>
      <stop offset=".5" stop-color="#000" stop-opacity="0"/>
      <stop offset=".86" stop-color="#000" stop-opacity="${shadeA * 0.12}"/>
      <stop offset="1" stop-color="#000" stop-opacity="${shadeA}"/>
    </linearGradient>
    <linearGradient id="${uid}-gy" gradientUnits="userSpaceOnUse" x1="0" x2="0" y1="20" y2="620">
      <stop offset="0" stop-color="#fff" stop-opacity="${hiA}"/>
      <stop offset=".45" stop-color="#fff" stop-opacity="${hiA * 0.25}"/>
      <stop offset="1" stop-color="#000" stop-opacity="${shadeA * 0.5}"/>
    </linearGradient>
    <radialGradient id="${uid}-gr" cx=".5" cy=".38" r=".6">
      <stop offset="0" stop-color="#fff" stop-opacity="${hiA * 0.9}"/>
      <stop offset="1" stop-color="#fff" stop-opacity="0"/>
    </radialGradient>
    ${o.texture ? `<filter id="${uid}-tx" x="0" y="0" width="100%" height="100%"><feTurbulence type="fractalNoise" baseFrequency=".85" numOctaves="2" seed="4" result="n"/><feColorMatrix in="n" type="matrix" values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 .55 -.18"/><feComposite in2="SourceGraphic" operator="in"/></filter>` : ''}`;
}

// Weicher Boden-Schatten unter der Ware
const groundShadow = (cx, cy, rx, ry) =>
  `<ellipse cx="${cx}" cy="${cy}" rx="${rx}" ry="${ry}" fill="#000" opacity=".16" filter="blur(0)"/>`;

// Falten (leicht, asymmetrisch) – opacity je nach Helligkeit
function folds(paths, light) {
  const a = light ? 0.13 : 0.2;
  const b = light ? 0.28 : 0.07;
  return paths
    .map(
      (d, i) =>
        `<path d="${d}" fill="none" stroke="#000" stroke-opacity="${a}" stroke-width="${i % 2 ? 3 : 4}" stroke-linecap="round"/>` +
        `<path d="${d}" transform="translate(5 3)" fill="none" stroke="#fff" stroke-opacity="${b}" stroke-width="2.4" stroke-linecap="round"/>`,
    )
    .join('');
}

// Logo in einer Druckfläche platzieren (zentriert, skaliert, optional Multiply für bedruckte helle Ware)
function placeLogo(area, o, garmentLight, opts = {}) {
  const logo = o.logo;
  if (!logo) return '';
  const { x, y, w, h } = logoRect(area, logo, o, opts.pad ?? 0.9);
  const blend = opts.noBlend ? '' : garmentLight ? 'style="mix-blend-mode:multiply"' : '';
  const op = opts.opacity ?? (garmentLight ? 0.94 : 0.97);
  const frame = o.showArea
    ? `<rect x="${area.x}" y="${area.y}" width="${area.w}" height="${area.h}" rx="3" fill="none" stroke="${COLORS.ton}" stroke-width="1.6" stroke-dasharray="6 5" opacity=".75"/>`
    : '';
  let body;
  if (logo.kind === 'image') {
    body = `<image href="${esc(logo.href)}" x="${x.toFixed(1)}" y="${y.toFixed(1)}" width="${w.toFixed(1)}" height="${h.toFixed(1)}" preserveAspectRatio="xMidYMid meet" opacity="${op}" ${blend}/>`;
  } else {
    const c = sampleColors(garmentLight, o.ink);
    body = `<svg x="${x.toFixed(1)}" y="${y.toFixed(1)}" width="${w.toFixed(1)}" height="${h.toFixed(1)}" viewBox="0 0 ${logo.w} ${logo.h}" overflow="visible" opacity="${op}" ${blend}>${logo.markup(c)}</svg>`;
  }
  return frame + body;
}

// Platzhalter, wenn noch kein Logo gewählt ist (gestrichelte Fläche + Ton-Punkt)
function placeholder(area, garmentLight) {
  const c = garmentLight ? COLORS.tinte : COLORS.papier;
  const cx = area.x + area.w / 2, cy = area.y + area.h / 2;
  return `<g opacity=".7"><rect x="${area.x}" y="${area.y}" width="${area.w}" height="${area.h}" rx="4" fill="none" stroke="${c}" stroke-width="1.6" stroke-dasharray="5 6"/><circle cx="${cx}" cy="${cy}" r="${Math.max(3.5, Math.min(area.w, area.h) * 0.055)}" fill="${COLORS.ton}"/></g>`;
}

// ---------- Produktzeichnungen ----------
function art_tshirt(uid, hex, o, light) {
  const body = halves(uid, 'b', 'M300,128 Q268,128 234,62 L100,112 Q91,116 86,125 L16,240 Q12,249 21,254 L87,291 Q95,295 100,288 L143,225 L143,574 Q143,586 155,586 L300,586 Z');
  const rib = darker(hex, light ? 0.07 : 0);
  const back = o.view === 'back';
  const collarD = back
    ? 'M300,88 Q268,88 234,62 L247,57 Q272,77 300,77 Z'
    : 'M300,128 Q268,128 234,62 L247,57 Q272,114 300,114 Z';
  const collar = halves(uid, 'c', collarD);
  const inner = back
    ? ''
    : `<path d="M234,62 Q300,34 366,62 Q332,128 300,128 Q268,128 234,62 Z" fill="${darker(hex, 0.45)}"/>`;
  const sleeveHem = sides(uid, 'sh', 'M16,240 L87,291 L96,278 L28,226 Z');
  let g = `<defs>${body.def}${collar.def}${sleeveHem.def}${body.clip('cp')}</defs>`;
  g += groundShadow(300, 604, 190, 12);
  g += inner;
  g += body.use(`fill="${hex}"`);
  g += `<g clip-path="url(#${uid}-cp)">`;
  g += `<rect width="600" height="640" fill="url(#${uid}-gx)"/><rect width="600" height="640" fill="url(#${uid}-gy)"/>`;
  g += body.use(`fill="none" stroke="#000" stroke-opacity="${light ? 0.12 : 0.28}" stroke-width="14"`);
  g += folds(['M143,226 Q168,270 160,340', 'M457,226 Q432,270 440,340', 'M214,388 Q226,470 210,560', 'M392,420 Q380,490 396,566', 'M270,300 Q300,330 340,310'], light);
  g += '</g>';
  g += sleeveHem.use(`fill="${darker(hex, light ? 0.1 : -0.12)}" opacity=".55"`);
  g += collar.use(`fill="${mix(hex, light ? '#000' : '#fff', 0.1)}"`);
  g += collar.use(`fill="none" stroke="#000" stroke-opacity=".18" stroke-width="1.5"`);
  g += `<path d="M143,574 Q300,590 457,574" fill="none" stroke="#000" stroke-opacity=".16" stroke-width="2"/>`;
  return g;
}

function art_polo(uid, hex, o, light) {
  const body = halves(uid, 'b', 'M300,150 Q268,150 234,62 L100,112 Q91,116 86,125 L16,240 Q12,249 21,254 L87,291 Q95,295 100,288 L143,225 L143,574 Q143,586 155,586 L300,586 Z');
  const flap = sides(uid, 'f', 'M234,60 L300,150 L276,170 L208,84 Z');
  const sleeveHem = sides(uid, 'sh', 'M16,240 L87,291 L96,278 L28,226 Z');
  const flapC = mix(hex, light ? '#000' : '#fff', 0.08);
  let g = `<defs>${body.def}${flap.def}${sleeveHem.def}${body.clip('cp')}</defs>`;
  g += groundShadow(300, 604, 190, 12);
  g += `<path d="M234,62 Q300,34 366,62 Q332,150 300,150 Q268,150 234,62 Z" fill="${darker(hex, 0.45)}"/>`;
  g += body.use(`fill="${hex}"`);
  g += `<g clip-path="url(#${uid}-cp)">`;
  g += `<rect width="600" height="640" fill="url(#${uid}-gx)"/><rect width="600" height="640" fill="url(#${uid}-gy)"/>`;
  g += body.use(`fill="none" stroke="#000" stroke-opacity="${light ? 0.12 : 0.28}" stroke-width="14"`);
  g += folds(['M143,226 Q168,270 160,340', 'M457,226 Q432,270 440,340', 'M214,388 Q226,470 210,560', 'M392,420 Q380,490 396,566'], light);
  g += '</g>';
  g += sleeveHem.use(`fill="${darker(hex, light ? 0.1 : -0.12)}" opacity=".55"`);
  // Knopfleiste + Kragen
  g += `<rect x="286" y="150" width="28" height="112" fill="${mix(hex, light ? '#000' : '#fff', 0.05)}" stroke="#000" stroke-opacity=".16"/>`;
  g += `<circle cx="300" cy="186" r="4.6" fill="${light ? '#2a2f3d' : '#e9e2d3'}"/><circle cx="300" cy="224" r="4.6" fill="${light ? '#2a2f3d' : '#e9e2d3'}"/>`;
  g += flap.use(`fill="${flapC}" stroke="#000" stroke-opacity=".2" stroke-width="1.5" stroke-linejoin="round"`);
  return g;
}

function art_hoodie(uid, hex, o, light) {
  const back = o.view === 'back';
  const body = halves(uid, 'b', back
    ? 'M300,150 Q258,148 212,90 L110,126 Q98,131 92,144 L40,420 Q38,432 48,436 L118,452 Q128,454 132,444 L158,290 L156,584 Q156,594 166,594 L300,594 Z'
    : 'M300,178 Q256,172 212,90 L110,126 Q98,131 92,144 L40,420 Q38,432 48,436 L118,452 Q128,454 132,444 L158,290 L156,584 Q156,594 166,594 L300,594 Z');
  const hoodBack = halves(uid, 'hb', 'M300,6 C228,6 180,46 176,112 L216,100 C226,68 258,48 300,48 Z');
  const hoodIn = halves(uid, 'hi', 'M300,50 C256,50 228,76 218,112 Q262,188 300,196 Z');
  const hoodFlat = halves(uid, 'hf', 'M300,30 C238,30 196,62 190,112 C184,170 214,216 300,236 Z');
  const hem = halves(uid, 'hm', 'M156,562 L300,562 L300,594 L166,594 Q156,594 156,584 Z');
  const cuff = sides(uid, 'cf', 'M40,418 Q38,430 48,434 L118,450 Q128,452 132,442 L136,420 L44,392 Z');
  const pocket = halves(uid, 'pk', 'M300,414 L190,414 L162,544 L300,544 Z');
  const rib = mix(hex, light ? '#000' : '#fff', 0.09);
  let g = `<defs>${body.def}${hoodBack.def}${hoodIn.def}${hoodFlat.def}${hem.def}${cuff.def}${pocket.def}${body.clip('cp')}</defs>`;
  g += groundShadow(300, 612, 200, 12);
  // Kapuze (hinten)
  g += hoodBack.use(`fill="${mix(hex, '#000', light ? 0.12 : 0.1)}"`);
  if (back) g += hoodFlat.use(`fill="${hex}"`);
  g += body.use(`fill="${hex}"`);
  g += `<g clip-path="url(#${uid}-cp)">`;
  g += `<rect width="600" height="640" fill="url(#${uid}-gx)"/><rect width="600" height="640" fill="url(#${uid}-gy)"/>`;
  g += body.use(`fill="none" stroke="#000" stroke-opacity="${light ? 0.12 : 0.3}" stroke-width="14"`);
  g += folds(['M158,290 Q184,350 170,420', 'M442,290 Q416,350 430,420', 'M90,190 Q82,260 70,330', 'M512,200 Q518,270 530,330', 'M230,470 Q238,520 222,570'], light);
  g += '</g>';
  if (back) {
    g += hoodFlat.use(`fill="none" stroke="#000" stroke-opacity=".2" stroke-width="2"`);
    g += `<path d="M222,106 Q300,170 378,106" fill="none" stroke="#000" stroke-opacity=".14" stroke-width="3"/>`;
  } else {
    g += hoodIn.use(`fill="${mix(hex, '#000', 0.55)}"`);
    g += hoodIn.use(`fill="none" stroke="#000" stroke-opacity=".25" stroke-width="2"`);
    g += `<path d="M218,112 Q262,188 300,196 Q338,188 382,112" fill="none" stroke="${mix(hex, light ? '#000' : '#fff', 0.12)}" stroke-width="7" stroke-linecap="round"/>`;
    // Kängurutasche
    g += pocket.use(`fill="${mix(hex, '#000', light ? 0.04 : -0.02)}" stroke="#000" stroke-opacity=".2" stroke-width="2" stroke-linejoin="round"`);
    g += pocket.use(`fill="url(#${uid}-gy)" opacity=".7"`);
    g += `<path d="M190,414 L212,478 M410,414 L388,478" stroke="#000" stroke-opacity=".2" stroke-width="2" fill="none"/>`;
    // Kordeln
    const cord = light ? '#8f866f' : '#e8e0cf';
    g += `<path d="M276,188 Q272,222 270,262 M324,188 Q328,222 330,262" fill="none" stroke="${cord}" stroke-width="5" stroke-linecap="round"/><rect x="266" y="262" width="8" height="16" rx="2" fill="${light ? '#5b5646' : '#bdb59f'}"/><rect x="326" y="262" width="8" height="16" rx="2" fill="${light ? '#5b5646' : '#bdb59f'}"/>`;
  }
  // Bündchen
  g += hem.use(`fill="${rib}"`);
  g += cuff.use(`fill="${rib}"`);
  for (let i = 0; i < 14; i++) g += `<path d="M${164 + i * 10},566 V592" stroke="#000" stroke-opacity=".12" stroke-width="2"/><path d="M${436 - i * 10},566 V592" stroke="#000" stroke-opacity=".12" stroke-width="2"/>`;
  return g;
}

function art_beanie(uid, hex, o, light) {
  const rib = mix(hex, light ? '#000' : '#fff', 0.07);
  let g = '';
  g += groundShadow(300, 546, 210, 12);
  const dome = 'M112,368 C98,186 190,82 300,82 C410,82 502,186 488,368 Z';
  g += `<defs><clipPath id="${uid}-dc"><path d="${dome}"/></clipPath></defs>`;
  g += `<path d="${dome}" fill="${hex}"/>`;
  g += `<g clip-path="url(#${uid}-dc)">`;
  for (let t = -9; t <= 9; t++) {
    g += `<path d="M${300 + t * 5},90 Q${300 + t * 21},210 ${300 + t * 29},372" fill="none" stroke="#000" stroke-opacity="${light ? 0.1 : 0.22}" stroke-width="3"/>`;
    g += `<path d="M${303 + t * 5},90 Q${303 + t * 21},210 ${303 + t * 29},372" fill="none" stroke="#fff" stroke-opacity="${light ? 0.34 : 0.07}" stroke-width="2"/>`;
  }
  g += `<rect x="90" y="60" width="420" height="320" fill="url(#${uid}-gx)"/><rect x="90" y="60" width="420" height="320" fill="url(#${uid}-gr)"/>`;
  g += '</g>';
  // Umschlag
  g += `<rect x="92" y="354" width="416" height="164" rx="14" fill="${rib}"/>`;
  for (let i = 0; i < 41; i++) g += `<path d="M${104 + i * 10},362 V510" stroke="#000" stroke-opacity="${light ? 0.1 : 0.22}" stroke-width="3"/><path d="M${107 + i * 10},362 V510" stroke="#fff" stroke-opacity="${light ? 0.3 : 0.06}" stroke-width="2"/>`;
  g += `<rect x="92" y="354" width="416" height="164" rx="14" fill="url(#${uid}-gx)"/>`;
  g += `<path d="M96,356 H504" stroke="#000" stroke-opacity=".2" stroke-width="3"/>`;
  return g;
}

function art_socken(uid, hex, o, light) {
  // lokale Form: Schaft x 0–140, Fuß nach rechts bis 262, Höhe 400
  const sock = 'M0,0 L140,0 L140,236 Q140,262 160,270 L232,300 Q262,314 262,346 Q262,392 226,398 L52,398 Q0,398 0,350 Z';
  const rib = mix(hex, light ? '#000000' : '#ffffff', 0.08);
  const acc = COLORS.ton;
  const S = 0.92;
  const one = (side) => {
    const tr = side === 'front' ? 'translate(310 124) scale(' + S + ')' : 'translate(290 124) scale(' + (-S) + ' ' + S + ')';
    const sid = uid + '-' + side;
    return `<g transform="${tr}">
      <defs><clipPath id="${sid}-c"><path d="${sock}"/></clipPath></defs>
      <path d="${sock}" fill="${hex}"/>
      <g clip-path="url(#${sid}-c)">
        ${Array.from({ length: 14 }, (_, i) => '<path d="M' + (8 + i * 10) + ',0 V300" stroke="#000" stroke-opacity="' + (light ? 0.05 : 0.14) + '" stroke-width="2"/>').join('')}
        <path d="M0,330 Q0,398 52,398 L120,398 L120,360 Q70,340 40,300 Z" fill="${acc}"/>
        <path d="M236,300 Q262,314 262,346 Q262,392 226,398 L206,398 Q232,356 214,296 Z" fill="${acc}"/>
        <rect x="0" y="0" width="140" height="56" fill="${rib}"/>
        ${Array.from({ length: 14 }, (_, i) => '<path d="M' + (6 + i * 10) + ',2 V54" stroke="#000" stroke-opacity="' + (light ? 0.12 : 0.22) + '" stroke-width="3"/>').join('')}
        <path d="M0,56 H140" stroke="#000" stroke-opacity=".2" stroke-width="3"/>
        <rect x="0" y="62" width="140" height="7" fill="${acc}"/>
      </g>
    </g>`;
  };
  let g = '';
  g += groundShadow(300, 496, 250, 9);
  g += one('back');
  g += one('front');
  return g;
}

function art_slides(uid, hex, o, light) {
  const foot = 'M170,40 C238,40 262,110 262,190 C262,290 252,400 246,470 C240,540 218,600 170,600 C122,600 100,540 94,470 C88,400 78,290 78,190 C78,110 102,40 170,40 Z';
  const foot2 = 'M170,58 C226,58 248,118 248,190 C248,288 238,396 232,466 C227,528 208,586 170,586 C132,586 113,528 108,466 C102,396 92,288 92,190 C92,118 114,58 170,58 Z';
  const strap = 'M80,168 C80,136 128,116 170,116 C212,116 260,136 260,168 L260,244 C260,218 214,196 170,196 C126,196 80,218 80,244 Z';
  const half = halves(uid, 'sl', foot);
  const sole = darker(hex, light ? 0.18 : -0.18);
  const bed = lighter(hex, light ? 0.0 : 0.1);
  let g = `<defs><path id="${uid}-ft" d="${foot}"/><path id="${uid}-fb" d="${foot2}"/><path id="${uid}-st" d="${strap}"/></defs>`;
  g += groundShadow(300, 612, 250, 10);
  const one = (extra) => `<g ${extra}>
    <use href="#${uid}-ft" fill="${sole}"/>
    <use href="#${uid}-fb" fill="${bed}"/>
    <use href="#${uid}-fb" fill="url(#${uid}-gy)"/>
    <path d="M126,262 C146,300 196,300 214,262" stroke="#000" stroke-opacity=".08" stroke-width="3" fill="none"/><ellipse cx="170" cy="512" rx="52" ry="46" fill="#000" opacity=".07"/><path d="M170,262 C150,380 150,470 170,540" stroke="#000" stroke-opacity=".06" stroke-width="18" fill="none" stroke-linecap="round"/>
    <use href="#${uid}-st" fill="${hex}" stroke="#000" stroke-opacity=".22" stroke-width="2"/>
    <use href="#${uid}-st" fill="url(#${uid}-gy)"/>
    <path d="M80,244 C80,218 126,196 170,196 C214,196 260,218 260,244" fill="none" stroke="#000" stroke-opacity=".28" stroke-width="3"/>
  </g>`;
  g += one('');
  g += one('transform="translate(600 0) scale(-1 1)"');
  return g;
}

function art_flasche(uid, hex, o, light) {
  const bodyD = 'M216,214 C216,164 252,146 256,130 L344,130 C348,146 384,164 384,214 L384,572 Q384,594 362,594 L238,594 Q216,594 216,572 Z';
  const shoulder = 'M256,130 L344,130 L344,132 L256,132 Z';
  const cap = 'M254,54 L346,54 Q354,54 354,62 L354,132 L246,132 L246,62 Q246,54 254,54 Z';
  const capHex = light ? '#2b3042' : mix(hex, '#fff', 0.5);
  let g = '';
  g += groundShadow(300, 604, 120, 9);
  g += `<defs><clipPath id="${uid}-bc"><path d="${bodyD}"/><path d="${shoulder}"/></clipPath></defs>`;
  g += `<path d="${bodyD}" fill="${hex}"/><path d="${shoulder}" fill="${hex}"/>`;
  g += `<g clip-path="url(#${uid}-bc)">`;
  g += `<rect x="200" y="120" width="200" height="490" fill="url(#${uid}-gx)"/>`;
  g += `<rect x="236" y="140" width="22" height="440" fill="#fff" opacity="${light ? 0.45 : 0.14}"/><rect x="262" y="140" width="6" height="440" fill="#fff" opacity="${light ? 0.2 : 0.07}"/>`;
  g += `<rect x="200" y="560" width="200" height="40" fill="#000" opacity=".12"/>`;
  g += '</g>';
  g += `<path d="${cap}" fill="${capHex}"/>`;
  for (let i = 0; i < 10; i++) g += `<path d="M${255 + i * 10},58 V128" stroke="#000" stroke-opacity=".25" stroke-width="2"/>`;
  g += `<rect x="246" y="54" width="108" height="78" fill="url(#${uid}-gx)" opacity=".8"/>`;
  g += `<path d="M246,132 H354" stroke="#000" stroke-opacity=".3" stroke-width="3"/>`;
  return g;
}

function art_tasche(uid, hex, o, light) {
  const bodyD = 'M122,192 L478,192 L492,586 L108,586 Z';
  const hand1 = 'M206,200 C206,68 394,68 394,200';
  const hand2 = 'M166,200 C166,34 434,34 434,200';
  const hc = darker(hex, light ? 0.14 : -0.1);
  let g = '';
  g += groundShadow(300, 602, 210, 11);
  g += `<path d="${hand2}" fill="none" stroke="${darker(hex, light ? 0.22 : -0.04)}" stroke-width="16" stroke-linecap="round"/>`;
  g += `<defs><clipPath id="${uid}-tc"><path d="${bodyD}"/></clipPath></defs>`;
  g += `<path d="${bodyD}" fill="${hex}"/>`;
  g += `<g clip-path="url(#${uid}-tc)"><rect x="100" y="180" width="400" height="420" fill="url(#${uid}-gx)"/><rect x="100" y="180" width="400" height="420" fill="url(#${uid}-gy)"/>`;
  for (let i = 0; i < 24; i++) g += `<path d="M${118 + i * 16},190 V590" stroke="#000" stroke-opacity="${light ? 0.035 : 0.09}" stroke-width="1.5"/>`;
  g += folds(['M140,330 Q170,420 150,540', 'M470,300 Q440,400 458,540'], light);
  g += '</g>';
  g += `<path d="M122,198 H478" stroke="#000" stroke-opacity=".22" stroke-width="3"/><path d="M122,206 H478" stroke="#fff" stroke-opacity=".18" stroke-width="2"/>`;
  g += `<path d="${hand1}" fill="none" stroke="${hc}" stroke-width="20" stroke-linecap="round"/><path d="${hand1}" fill="none" stroke="#fff" stroke-opacity="${light ? 0.35 : 0.1}" stroke-width="3" transform="translate(-3 -3)" stroke-linecap="round"/>`;
  g += `<rect x="196" y="190" width="20" height="28" fill="${hc}"/><rect x="384" y="190" width="20" height="28" fill="${hc}"/>`;
  g += `<path d="M196,218 H216 M384,218 H404" stroke="#000" stroke-opacity=".25" stroke-width="2"/>`;
  return g;
}

function art_notizbuch(uid, hex, o, light) {
  const cover = 'M168,64 L440,64 Q452,64 452,76 L452,576 Q452,588 440,588 L168,588 Q156,588 156,576 L156,76 Q156,64 168,64 Z';
  let g = '';
  g += groundShadow(310, 604, 170, 9);
  g += `<path d="M452,86 L466,92 L466,574 L452,578 Z" fill="#efe9dc" stroke="#000" stroke-opacity=".2"/>`;
  for (let i = 0; i < 24; i++) g += `<path d="M452,${96 + i * 20} L466,${100 + i * 20}" stroke="#000" stroke-opacity=".1"/>`;
  g += `<defs><clipPath id="${uid}-nc"><path d="${cover}"/></clipPath></defs>`;
  g += `<path d="${cover}" fill="${hex}"/>`;
  g += `<g clip-path="url(#${uid}-nc)"><rect x="150" y="60" width="310" height="534" fill="url(#${uid}-gx)"/><rect x="150" y="60" width="310" height="534" fill="url(#${uid}-gy)"/>`;
  g += `<rect x="156" y="64" width="30" height="524" fill="#000" opacity="${light ? 0.12 : 0.28}"/><path d="M186,64 V588" stroke="#fff" stroke-opacity="${light ? 0.4 : 0.1}" stroke-width="2"/>`;
  g += `<rect x="398" y="64" width="14" height="524" fill="#000" opacity=".5"/><rect x="398" y="64" width="14" height="524" fill="url(#${uid}-gx)"/>`;
  g += '</g>';
  return g;
}

const DRAW = {
  tshirt: art_tshirt, hoodie: art_hoodie, polo: art_polo, beanie: art_beanie, socken: art_socken,
  slides: art_slides, flasche: art_flasche, tasche: art_tasche, notizbuch: art_notizbuch,
};

// Namen/Nummer auf der Rückseite
function backText(kind, o, light) {
  const spec = BACK[kind];
  if (!spec) return '';
  const col = o.ink && o.ink !== 'original' ? o.ink : light ? COLORS.tinte : COLORS.papier;
  const fam = o.font === 'klar' ? 'Inter, Arial, sans-serif' : 'Fraunces, Georgia, serif';
  const wt = o.font === 'klar' ? 800 : 700;
  const sty = o.font === 'kursiv' ? 'italic' : 'normal';
  let g = '';
  const name = (o.name || '').toUpperCase();
  const num = (o.number || '').slice(0, 3);
  if (name) {
    const n = spec.name;
    const fs = Math.min(46, (n.w / Math.max(4, name.length)) * 1.55);
    g += `<text x="${n.x + n.w / 2}" y="${n.y + n.h * 0.74}" text-anchor="middle" font-family="${fam}" font-weight="${wt}" font-style="${sty}" font-size="${fs.toFixed(1)}" letter-spacing="3" fill="${col}" opacity=".96">${esc(name)}</text>`;
  }
  if (num) {
    const n = spec.num;
    const fs = num.length > 2 ? 150 : num.length > 1 ? 200 : 230;
    g += `<text x="${n.x + n.w / 2}" y="${n.y + n.h * 0.86}" text-anchor="middle" font-family="${fam}" font-weight="${wt}" font-style="${sty}" font-size="${fs}" fill="${col}" opacity=".96">${esc(num)}</text>`;
  }
  return g;
}

// ---------- Öffentliche API ----------
// kind: tshirt|hoodie|polo|beanie|socken|slides|flasche|tasche|notizbuch
// o: { color, view, logo, scale, ink, name, number, font, uid, texture, showArea, bg, placeholder, title }
function productSVG(kind, o = {}) {
  const colorKey = o.color && GARMENT[o.color] ? o.color : 'tinte';
  const gm = GARMENT[colorKey];
  const uid = o.uid || nextUid();
  const hex = gm.hex;
  const light = gm.light;
  const draw = DRAW[kind];
  if (!draw) throw new Error('Unbekanntes Produkt: ' + kind);
  const view = o.view === 'back' && BACK[kind] ? 'back' : 'front';
  const oo = { ...o, view };
  const area = placeArea(kind, o.place);
  let inner = draw(uid, hex, oo, light);
  if (view === 'front' && area) {
    const areas = [area, ...(area.extra || []).map((e) => ({ ...area, ...e, extra: undefined }))];
    for (const ar of areas) {
      if (o.logo) {
        const engr = kind === 'flasche' || kind === 'notizbuch';
        inner += placeLogo(ar, o, light, { noBlend: engr && !light, opacity: engr ? 0.92 : undefined });
      } else if (o.placeholder !== false) inner += placeholder(ar, light);
      else if (o.showArea) inner += `<rect x="${ar.x}" y="${ar.y}" width="${ar.w}" height="${ar.h}" fill="none" stroke="${COLORS.ton}" stroke-dasharray="6 5"/>`;
    }
  }
  if (view === 'back') inner += backText(kind, o, light);
  const bg = o.bg === false ? '' : `<rect width="${W}" height="${H}" fill="${o.bgColor || gm.stage}"/>`;
  const defs = `<defs>${baseDefs(uid, hex, oo)}</defs>`;
  const tex = o.texture
    ? ''
    : '';
  const title = o.title ? `<title>${esc(o.title)}</title>` : '';
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${W} ${H}" role="img" ${o.title ? '' : 'aria-hidden="true"'} focusable="false" class="${o.class || 'art'}">${title}${defs}${bg}${inner}${tex}</svg>`;
}

const KINDS = Object.keys(DRAW);

window.GlyfaArt = { W, H, COLORS, GARMENT, mix, lum, AREAS, PLACEMENTS, placeArea, logoRect, BACK, SAMPLE_LOGOS, sampleColors, productSVG, KINDS, nextUid };
})();
